<template>
  <h3 class="pb5">Dossiers d'autoexclusion actifs d'Espacejeux (CDX_0260)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersEspaceJeuxAutoexclusionActif",
  components: {ButtonBar},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("EspaceJeux");
  },
  data() {
    return {
      criteresRecherche: {}
    }
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.criteresRecherche.typeRapport = "Excel"
      this.criteresRecherche.titre = "DossiersCumulatifEspaceJeux";
      this.criteresRecherche.nomRapport = "espaceJeux.EspaceJeuxAutoexclusionActifGenerateurRapport_CDX_0260";
      this.$store.dispatch("rapports/obtenirRapportAction", this.criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>
